import React from 'react'

const CONNECTOR_TABS = [
    { key: 'Details', label: 'Details' },
    { key: 'ManageEntities', label: 'Manage Entities' },
    { key: 'Mappings', label: 'Mappings' },
    { key: 'AttributeMappings', label: 'Attribute Mappings' },
]

// These tabs open their own full page instead of rendering inside the connector card.
const PAGE_TAB_KEYS = ['Mappings', 'AttributeMappings']

/**
 * Connector tabs. The highlight comes from the activeTab prop rather than a class
 * toggled on the DOM, so it cannot drift from what is actually rendered.
 */
const Tabs = ({ activeTab, getActiveTab }) => (
    <div className="tabMenuContainer">
        <ul className="nav">
            {CONNECTOR_TABS.map((tab) => (
                <li className="nav-item" key={tab.key}>
                    <button
                        type="button"
                        className={`nav-link tabItem${tab.key === activeTab ? ' active' : ''}`}
                        aria-current={tab.key === activeTab ? 'page' : undefined}
                        onClick={() => getActiveTab(tab.key)}
                    >
                        {PAGE_TAB_KEYS.includes(tab.key) ? (
                            <span className="mappingTabContent">
                                <span>{tab.label}</span>
                                <i className="uil-arrow-right" aria-hidden="true" />
                            </span>
                        ) : tab.label}
                    </button>
                </li>
            ))}
        </ul>
    </div>
)

export default Tabs
